// @flow
import React from 'react';
import { isBrowser } from 'react-device-detect';
import MarkdownEditor from 'components/common/MarkdownEditor';
import Button from 'components/common/Button';
import './UserAboutEdit.scss';

type Props = {
  text: string,
  onChange: (text: string) => void,
  onSave: () => any,
  flash: string,
};

const UserAboutEdit = ({ text, onChange, onSave, flash }: Props) => {
  return (
    <div className="UserAboutEdit">
      <MarkdownEditor
        placeholder="브랜드 소개를 등록해보세요."
        value={text}
        onChange={onChange}
        flash={flash}
      />
      <div className="btn-wrapper">
        <Button large onClick={onSave} desktop={isBrowser}>
          저장
        </Button>
      </div>
    </div>
  );
};

export default UserAboutEdit;



// WEBPACK FOOTER //
// ./src/components/user/UserAboutEdit/UserAboutEdit.js